import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import { EnumValidValueItemModel } from '../../../../../models/enum/enum-valid-value-item.model';
import { StaticDataService } from '../../../../../services/static-data.service';
import { EndoMultiToothExamDataModel } from '../../../../../models/forms/custom/mti/endo-multi-tooth-exam-data.model';
import { EndoMultiToothExamToothDataModel } from '../../../../../models/forms/custom/mti/endo-multi-tooth-exam-tooth-data.model';
import { MtiService } from '../../../../../services/form/mti.service';
import { ToothConfigurationModel } from '../../../../../models/teeth/tooth-configuration.model';
import { DialogService } from '../../../../../services/dialog.service';
import { Globals } from '../../../../../globals';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ToothUiManagerModel } from '../../../../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.model';
import { EndoMultiToothExamAutoFillConfigurationModel } from '../../../../../models/forms/custom/mti/endo-multi-tooth-exam-auto-fill-configuration.model';
import { TdoDropdownChange } from '../../../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { OrderUpdateModel } from '../../../../../models/order-update.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { EndoMultiToothExamCavityDataModel } from '../../../../../models/forms/custom/mti/endo-multi-tooth-exam-cavity-data.model';
import { EndoMultiToothExamSurfaceDataModel } from '../../../../../models/forms/custom/mti/endo-multi-tooth-exam-surface-data.model';
import { EndoMultiToothExamSurfaceAutofillConfigurationModel } from '../../../../../models/forms/custom/mti/endo-multi-tooth-exam-surface-autofill-configuration.model';
import { TdoDropdownV2Component } from '../../../../../tdo-controls/common/tdo-dropdown-v2/tdo-dropdown-v2.component';
import { MessagingService } from '../../../../../services/messaging.service';
import { MessagingConstants } from '../../../../../models/MessagingConstants';
import { EndoMultiToothExamTeethInExamDataModel } from '../../../../../models/forms/custom/mti/endo-multi-tooth-exam-teeth-in-exam-data.model';
import { ConsoleLogger } from '@angular/compiler-cli';

@Component({
  selector: 'app-mti-teeth',
  templateUrl: './mti-teeth.component.html',
  styleUrls: ['./mti-teeth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MtiTeethComponent implements OnInit {
  @Input() examModel: EndoMultiToothExamDataModel;
  @Input() cfgTeeth: ToothConfigurationModel[];
  @Input() examAutofills: EndoMultiToothExamAutoFillConfigurationModel[] = [];
  @Input() isSingleToothDialogMode = false;

  @Output() refreshExams: EventEmitter<any> = new EventEmitter<any>();

  @ViewChildren(TdoDropdownV2Component) dds: QueryList<TdoDropdownV2Component>;

  isShowMore = false;
  isLocked = false;

  toothSurfaceEnums: EnumValidValueItemModel[] = [];
  toothCanalEnums: EnumValidValueItemModel[] = [];
  probingDepthEnums: EnumValidValueItemModel[] = [];

  probingDepthAutofills: EndoMultiToothExamSurfaceAutofillConfigurationModel[] = [];
  isUserInput: boolean;



  constructor(private staticDataService: StaticDataService,
    private globals: Globals,
    private mtiService: MtiService,
    private dialogService: DialogService,
    private messagingService: MessagingService,
    private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    // this.isLocked = this.checkIsLocked();

    for (const tooth of this.examModel.dataEndoMutiToothExamTeethinExams) {
      tooth.isLocked = this.checkIsLocked(tooth);
    }

    if (this.staticDataService.isReady) {
      this.setupEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    }
  }

  setupEnums() {
    this.toothSurfaceEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothSurface');
    this.toothCanalEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothCanal');
    this.probingDepthEnums = this.staticDataService.getValidValueItemsByValidValueName('enumProbingDepth');

    this.mtiService.getSurfaceProbingAutofills().subscribe((res) => {
      this.probingDepthAutofills = res;
    });
  }

  onAddNew() {
    this.dialogService.openToothPicker(true).subscribe((res) => {
      let selected: ToothConfigurationModel[] = res.map(p => p.toothModel);

      selected = selected.sort((a, b) => {
        return a.PhysicalVorder - b.PhysicalVorder || a.PhysicalHorderLR - b.PhysicalHorderLR;
      });

      let i = 0;
      for (const t of selected) {
        const tooth = new EndoMultiToothExamTeethInExamDataModel();
        tooth.MTEID = this.examModel.MTEID;
        tooth.ToothOrder = i++;
        const tt = new EndoMultiToothExamToothDataModel();
        tt.ToothId = t.ToothId;
        tooth.dataEndoMutiToothExamTooth = tt;
        this.saveTooth(tooth);
      }

      this.cd.markForCheck();
      /*this.mtiService.saveTooth(tooth).subscribe((res1) => {
        this.examModel.dataEndoMutiToothExamTeethinExams.push(res);
        this.cd.markForCheck();
      });*/
    });
  }

  checkIsLocked(tooth: EndoMultiToothExamTeethInExamDataModel) {
    const nowDate = new Date();
    const createdDate = new Date(tooth.xauditCreatedOn);
    const msDiff = nowDate.getTime() - createdDate.getTime();

    // Num milliseconds in 24 hours 86400000
    return msDiff >= 86400000;
  }

  toggleLock(tooth: EndoMultiToothExamTeethInExamDataModel) {
    tooth.isLocked = !tooth.isLocked;
  }

  clear(tooth: EndoMultiToothExamTeethInExamDataModel) {
    const newTooth = new EndoMultiToothExamToothDataModel();
    newTooth.ToothId = tooth.dataEndoMutiToothExamTooth.ToothId;
    newTooth.MTEToothID = tooth.dataEndoMutiToothExamTooth.MTEToothID;
    tooth.dataEndoMutiToothExamTooth = newTooth;
    this.mtiService.saveTooth(tooth).subscribe((res) => {
      //
      const idx = this.examModel.dataEndoMutiToothExamTeethinExams.findIndex(p => p.MTETiithInExanID === tooth.MTETiithInExanID);
      if (idx > -1) {
        this.examModel.dataEndoMutiToothExamTeethinExams[idx] = res;
      }
      this.cd.markForCheck();
    });
  }

  delete(tooth: EndoMultiToothExamTeethInExamDataModel) {
    this.mtiService.deleteTooth(tooth).subscribe((res) => {
      const idx = this.examModel.dataEndoMutiToothExamTeethinExams.findIndex(p => p === tooth);
      if (idx > -1) {
        this.examModel.dataEndoMutiToothExamTeethinExams.splice(idx, 1);
        this.cd.markForCheck();
      }
    });
  }

  showMessage(message) {
    this.dialogService.openConfirmDialog(message, false, false, 'Alert').subscribe((res) => {

    });
  }

  download(tooth: EndoMultiToothExamTeethInExamDataModel) {
    if (!tooth.dataEndoMutiToothExamTooth.isToothDownloaded) {
      this.examModel.dataEndoMutiToothExamTeethinExams.find(p => p.MTETiithInExanID === tooth.MTETiithInExanID).dataEndoMutiToothExamTooth.isToothDownloaded = true;
      //backup the caseWorkItemID for the fees
      localStorage.setItem('currentPatientCaseWorkItemIDForFees', this.globals.currentPatientCaseWorkItemID);
      localStorage.setItem('isSelectedMTI', 'true');
      this.mtiService.downloadTeeth([tooth], this.globals.currentPatientCaseWorkItemID).subscribe((res) => {
        //this.messagingService.sendComponentMessage(MessagingConstants.CASE_FORMS_REFRESH, {});
        this.messagingService.sendComponentMessage(MessagingConstants.CASES_REFRESH, res);
      });
      this.cd.markForCheck();
    }
    else {
      this.showMessage('Tooth was already downloaded.');
    }
  }

  setUserInput(event: boolean) {
    this.isUserInput = event;
  }
  saveToothEvent($event: EnumValidValueItemModel, tooth: EndoMultiToothExamTeethInExamDataModel) {
    console.log("saveToothEvent", $event);
    if (this.isUserInput) {
      console.log("saveTooth");
      this.saveTooth(tooth);
    }
  }
  saveTooth(tooth: EndoMultiToothExamTeethInExamDataModel) {
    this.mtiService.saveTooth(tooth).subscribe((res) => {
      //
      const exists = this.examModel.dataEndoMutiToothExamTeethinExams.find(p => p.MTETiithInExanID === res.MTETiithInExanID);
      if (!exists) {
        this.examModel.dataEndoMutiToothExamTeethinExams.push(res);
      }
      this.examModel.dataEndoMutiToothExamTeethinExams = this.examModel.dataEndoMutiToothExamTeethinExams.sort((a, b) => {
        return a.ToothOrder - b.ToothOrder;
      });
      this.cd.markForCheck();
    });
  }

  getToothNum(dataEndoMutiToothExamTooth: EndoMultiToothExamToothDataModel) {
    const tooth = this.cfgTeeth.find(p => p.ToothId.toLowerCase() === dataEndoMutiToothExamTooth.ToothId.toLowerCase());
    if (tooth) {
      return tooth.cfgToothDescriptions[0].Notation;
    }

    return '';
  }

  openToothPicker(tooth: EndoMultiToothExamTeethInExamDataModel, isMultiTooth = false) {
    this.dialogService.openToothPicker(isMultiTooth).subscribe((res) => {
      const selectedTooth = res[0] as ToothUiManagerModel;
      tooth.dataEndoMutiToothExamTooth.ToothId = selectedTooth.toothModel.ToothId;
      this.saveTooth(tooth);
    });
  }

  onDropRow(event: CdkDragDrop<EndoMultiToothExamTeethInExamDataModel[]>) {
    moveItemInArray(this.examModel.dataEndoMutiToothExamTeethinExams, event.previousIndex, event.currentIndex);
    const models: OrderUpdateModel[] = [];
    let i = 0;
    for (const mod of this.examModel.dataEndoMutiToothExamTeethinExams) {
      const model = new OrderUpdateModel();
      model.guid = mod.MTETiithInExanID;
      model.order = i;
      models.push(model);
      i++;
    }
    this.mtiService.updateTeethOrder(models).subscribe(() => {

    });
    /*this.cd.markForCheck();*/
  }

  onAutofillSelectionChange(event: TdoDropdownChange, tooth: EndoMultiToothExamTeethInExamDataModel) {
    const t = tooth.dataEndoMutiToothExamTooth;
    const selection = event.value as EndoMultiToothExamAutoFillConfigurationModel;
    t.enumMTEChiefComplaintID = selection?.enumMTEChiefComplaintID;
    t.enumMTEPalpationID = selection?.enumMTEPalpationID;
    t.enumMTEPercussionID = selection?.enumMTEPercussionID;
    t.enumMTEMobilityID = selection?.enumMTEMobilityID;
    t.enumMTEChewingID = selection?.enumMTEChewingID;
    t.enumMTEBiteID = selection?.enumMTEBiteID;
    t.enumMTEAirID = selection?.enumMTEAirID;
    t.enumMTEColdID = selection?.enumMTEColdID;
    t.enumMTEHotID = selection?.enumMTEHotID;
    t.enumMTEeptID = selection?.enumMTEeptID;
    t.enumMTESinusTrackID = selection?.enumMTESinusTrackID;
    t.enumMTEOccusalTraumaID = selection?.enumMTEOccusalTraumaID;
    t.enumMTEFractureID = selection?.enumMTEFractureID;
    t.enumMTEPulpDiagID = selection?.enumMTEPulpDiagID;
    t.enumMTEPerDiagID = selection?.enumMTEPerDiagID;
    t.enumMTEEndoPrognosisID = selection?.enumMTEEndoPrognosisID;
    t.enumMTEPerioPrognosisID = selection?.enumMTEPerioPrognosisID;
    t.enumMTERestorPrognosisID = selection?.enumMTERestorPrognosisID;
    t.enumMTERecomendedTxID = selection?.enumMTERecomendedTxID;
    t.enumMTERecomendedTx_AfterID = selection?.enumMTERecomendedTx_AfterID;
    t.enumMTERecomendedTx_ThirdID = selection?.enumMTERecomendedTx_ThirdID;
    t.enumMTETretmentOrderID = selection?.enumMTETretmentOrderID;
    t.enumMTENumberOfVisitsID = selection?.enumMTENumberOfVisitsID;
    t.enumMTEVitalTestCavityID = selection?.enumMTEVitalTestCavityID;
    t.enumMTESweetsID = selection?.enumMTESweetsID;
    t.enumMTEFlossingID = selection?.enumMTEFlossingID;
    t.enumMTELayingDownID = selection?.enumMTELayingDownID;
    t.enumMTEExersiseBPID = selection?.enumMTEExersiseBPID;
    t.enumMTEHeadPosistionID = selection?.enumMTEHeadPosistionID;
    t.enumMTECervicalSensID = selection?.enumMTECervicalSensID;
    t.enumMTEBLateralForceID = selection?.enumMTEBLateralForceID;
    t.enumMTELLateralForceID = selection?.enumMTELLateralForceID;
    this.cd.markForCheck();
    this.saveTooth(tooth);
  }

  getDate(xauditCreatedOn: Date) {
    return new Date(xauditCreatedOn).toLocaleDateString();
  }

  updateView() {
    this.cd.markForCheck();
  }

  getToothSurfaces(tooth: EndoMultiToothExamTeethInExamDataModel) {
    const items: EnumValidValueItemModel[] = [];
    const cfgTooth = this.cfgTeeth.find(p => p.ToothId === tooth.dataEndoMutiToothExamTooth.ToothId);
    if (cfgTooth) {
      for (const surf of cfgTooth.cfgToothSurfaces) {
        const enu = this.toothSurfaceEnums.find(p => p.ValidValueItemId === surf.enumToothSurfaceID);
        if (enu) {
          items.push(enu);
        }
      }
    }
    return items;
  }

  getToothCanals(tooth: EndoMultiToothExamTeethInExamDataModel) {
    const items: EnumValidValueItemModel[] = [];
    const cfgTooth = this.cfgTeeth.find(p => p.ToothId === tooth.dataEndoMutiToothExamTooth.ToothId);
    if (cfgTooth) {
      for (const canal of cfgTooth.cfgToothCanals) {
        const enu = this.toothCanalEnums.find(p => p.ValidValueItemId === canal.enumToothCanalID);
        if (enu) {
          items.push(enu);
        }
      }
    }
    return items;
  }

  onSurfaceSelection(event: MatCheckboxChange, tooth: EndoMultiToothExamTeethInExamDataModel, enu: EnumValidValueItemModel) {
    if (event.checked) {
      const carie = new EndoMultiToothExamCavityDataModel();
      carie.ToothSurfaceId = enu.ValidValueItemId;
      carie.MTEToothID = tooth.dataEndoMutiToothExamTooth.MTEToothID;
      carie.isCavity = tooth.dataEndoMutiToothExamTooth.isCavity;
      this.mtiService.addCarie(carie).subscribe((res) => {
        tooth.dataEndoMutiToothExamTooth.dataEndoMutiToothExamTeethCavities.push(res);
      });
    } else {
      const car = tooth.dataEndoMutiToothExamTooth.dataEndoMutiToothExamTeethCavities.find(p => p.ToothSurfaceId === enu.ValidValueItemId);
      this.mtiService.removeCarie(car).subscribe(() => {
        //
        const idx = tooth.dataEndoMutiToothExamTooth.dataEndoMutiToothExamTeethCavities.findIndex(p => p.MTEToothCavitieID === car.MTEToothCavitieID);
        if (idx > -1) {
          tooth.dataEndoMutiToothExamTooth.dataEndoMutiToothExamTeethCavities.splice(idx, 1);
        }
      });
    }
  }

  isToothHasSurfaceSelected(tooth: EndoMultiToothExamTeethInExamDataModel, carie: EnumValidValueItemModel) {
    const t = tooth.dataEndoMutiToothExamTooth.dataEndoMutiToothExamTeethCavities.find(p => p.ToothSurfaceId === carie.ValidValueItemId);
    return !!t;

  }

  onProbingDepthChange(event: TdoDropdownChange, tooth: EndoMultiToothExamTeethInExamDataModel, surface: EnumValidValueItemModel) {
    console.log("onProbingDepthChange isuserinput", event.isUserInput);
    if (event.isUserInput) {
      const probingEnu = event.value as EnumValidValueItemModel;

      const mod = new EndoMultiToothExamSurfaceDataModel();
      mod.enumProbingDepthID = probingEnu?.ValidValueItemId;
      // ISSUE HERE
      mod.ToothSurfaceId = this.cfgTeeth.find(p => p.ToothId === tooth.dataEndoMutiToothExamTooth.ToothId).cfgToothSurfaces.find(e => e.enumToothSurfaceID === surface.ValidValueItemId).ToothSurfaceId;
      mod.MTEToothID = tooth.MTEToothID;
      this.mtiService.addSurfaceProbingDepth(mod).subscribe((res) => {

      });
    }
  }

  getSelectedToothSurfaceProbingDepth(tooth: EndoMultiToothExamTeethInExamDataModel, surface: EnumValidValueItemModel) {
    // const can = tooth.dataEndoMutiToothExamTooth.dataEndoMutiToothExamSurfaces.find(p => p.enumProbingDepthID === tooth.dataEndoMutiToothExamTooth.dataEndoMutiToothExamSurfaces.find(e => e.ToothSurfaceId).ToothSurfaceId);
    const cfgSurface = this.cfgTeeth.find(p => p.ToothId === tooth.dataEndoMutiToothExamTooth.ToothId).cfgToothSurfaces.find(p => p.enumToothSurfaceID === surface.ValidValueItemId);
    const surf = tooth.dataEndoMutiToothExamTooth.dataEndoMutiToothExamSurfaces.find(p => p.ToothSurfaceId === cfgSurface.ToothSurfaceId);
    if (surf) {
      const enu = this.probingDepthEnums.find(p => p.ValidValueItemId === surf.enumProbingDepthID);
      if (enu) {
        return enu;
      }
    }

    return null;
  }

  autofillProbingDepths(tooth: EndoMultiToothExamTeethInExamDataModel) {
    console.log("autofillProbingDepths", tooth);
    const autofillForTooth = this.probingDepthAutofills.find(p => p.ToothID === tooth.dataEndoMutiToothExamTooth.ToothId);
    if (autofillForTooth) {
      console.log("autofillProbingDepths autofillForTooth", autofillForTooth);

      for (const detail of autofillForTooth.cfgEndoMultiToothExamSurfaceAutofillDetails) {
          const mod = new EndoMultiToothExamSurfaceDataModel();
          mod.enumProbingDepthID = detail.enumProbingDepthID;
          // ISSUE HERE
          mod.ToothSurfaceId = detail.ToothSurfaceId;
          mod.MTEToothID = tooth.MTEToothID;
          this.mtiService.addSurfaceProbingDepth(mod).subscribe((res) => {
            // replace???
            let exist = tooth.dataEndoMutiToothExamTooth.dataEndoMutiToothExamSurfaces.find(p => p.ToothSurfaceId === detail.ToothSurfaceId);
            console.log("autofillProbingDepths exist in array:", tooth.dataEndoMutiToothExamTooth.dataEndoMutiToothExamSurfaces);
            console.log("autofillProbingDepths exist:", exist);

            if (exist) {
              exist = res;
            } else {
              console.log("autofillProbingDepths push:", res);
              tooth.dataEndoMutiToothExamTooth.dataEndoMutiToothExamSurfaces.push(res);
            }
            const id = tooth.MTETiithInExanID + '' + mod.ToothSurfaceId;
            for (const dd of this.dds) {
              console.log("autofillProbingDepths check value: ", id === dd.id, id, dd.id);

              if (id === dd.id) {
                console.log("autofillProbingDepths set value", dd);
                dd.value = this.probingDepthEnums.find(p => p.ValidValueItemId === res.enumProbingDepthID);
                dd.selected.setValue(dd.value);
              }
            }
            this.refreshExams.emit();
            this.cd.markForCheck();
          });
        
      }
    }
  }
}
